import { Reducer } from 'redux';
import {
  ACTION, 
  RequestLoadDraftsData, ReceiveLoadDraftsData, FailLoadDraftsData
} from './action-types';
import { CaseDraftInfoState } from './types';

const INITIAL_STATE: CaseDraftInfoState = {
  fetching: false,
  count: 0,
  data: undefined
};

const reducers = {
  [ACTION.RequestLoadDraftsData]: (state: CaseDraftInfoState, action: RequestLoadDraftsData): CaseDraftInfoState => ({
    ...state,
    fetching: true
  }),

  [ACTION.ReceiveLoadDraftsData]: (state: CaseDraftInfoState, action: ReceiveLoadDraftsData): CaseDraftInfoState => ({
    ...state,
    fetching: false,
    data: action.data.map(item => {
      return { ...item, caseType: item.caseType.d };
    }),
    count: action.data.length
  }),

  [ACTION.FailLoadDraftsData]: (state: CaseDraftInfoState, action: FailLoadDraftsData): CaseDraftInfoState => ({
    ...state,
    fetching: false
  })
} as { [key: string]: Reducer<CaseDraftInfoState> };

export const reducer: Reducer<CaseDraftInfoState> = (state: CaseDraftInfoState = INITIAL_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
